<template>
    <div class="row">
        <!-- <pre>{{ hasPackages }}</pre> -->
        <!-- input-hidden -->
        <input type="hidden" name="campaign" :value="campaign.id">
        <input type="hidden" name="year" :value="year">
        <!-- input field -->
        <div class="col">
            <input class="form-control" type="text" name="name" placeholder="Type plan title" required>
        </div>
        <div v-if="hasPackages" class="col-3">
            <select class="form-control" name="package">
                <option v-for="campaignPackage in campaignPackages" :value="campaignPackage.id">{{ campaignPackage.name[lang] }}</option>
            </select>
        </div>
        <div class="col-2">
            <div class="input-group">
                <span class="input-group-prepend">
                    <span class="input-group-text">RM</span>
                </span>
                <input class="form-control" type="text" name="target_collection" placeholder="0.00">
            </div>
        </div>
        <div class="col-3">
            <select class="form-control" name="pic">
                <option v-for="user in users" :value="user.id">{{ user.name.toUpperCase() }}</option>
            </select>
        </div>
        <div class="col-1 text-center">
            <button type="submit" class="btn btn-secondary form-control">Save</button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                hasPackages: false,
            };
        },
        props: [
            'lang',
            'campaign',
            'campaignPackages',
            'year',
            'users',
        ],
        computed: {

        },
        methods: {
            initData() {
                if (this.campaignPackages.length) {
                    this.hasPackages = true;
                }
            },
        },
        mounted() {
            this.initData();
        }
    }
</script>